<template>
    <div>
        <div class="row heading justify-content-center mb-5 mt-5">
            <div class="col">
                <h1 class="section-highlights headings serif">{{metricGlossaryData.name}}</h1>
                <span class="h-line"></span>
            </div>
        </div>
        <div class="row heading justify-content-center mb-5 mt-5">
            <div v-if="!reloading" class="col metric-glossary">
                <v-client-table :data="tblData" :columns="columns" :options="options"></v-client-table>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        props: ['isBuilt', 'metricGlossaryData'],
        created() {
            if(this.isBuilt){
                this.fetchServerData();
            }
        },
        data() {
            return {
                isArchive:this.$store.state.isArchive,
                errors:false,
                reloading:true,
                columns:[],
                options:{
                    headings:{},
                    filterable:false,
                    sortable: [],
                    texts:{
                        count:''
                    },
                    perPage: 25,
                    perPageValues:[25,50,100,1000],
                    skin: 'table'
                },
                tblData:[],
            }
        },
        mounted(){
            event_bus.$on('reloading', () => {
                this.reloading = true;
                this.fetchServerData();
            });
        },
        methods: {
            fetchServerData(){
                let params = {
                    'isArchive':            this.isArchive,
                    'prefixed_id':          this.isArchive ? this.metricGlossaryData.archive_id : this.metricGlossaryData.report_id,
                    'prefixed_element_id':  this.metricGlossaryData.report_element_id,
                    'element_abbr':         this.metricGlossaryData.element_abbreviation,
                    'element_id':           this.metricGlossaryData.element_id,
                    'element_name':         this.metricGlossaryData.name,
                };

                axios.post('/api/reporting/element', params).then((response) => {
                    if(!!response.data && (typeof(response.data) == 'object')){
                        this.errors = response.data.errors;
                    }
                    this.columns = response.data.columns;
                    this.options.headings = response.data.headings;
                    this.tblData = response.data.tblData;
                    this.reloading = false;
                });
            }
        }
    }
</script>
<style lang="scss">
    @import '~@/_variables.scss';
    div.heading{
        span.h-line{
            display:inline-block;
            border-top:0.3rem solid;
            border-bottom:0.3rem solid;
            border-radius:0.6rem;
            width:100%;
        }

        div.metric-glossary{
            div.VueTables{
                background-color:white;
            }
        }
    }
</style>
